import { Alert, Grid } from '@mui/material';
import { alpha, Theme } from '@mui/system';
import useSubscriberLists from '../../../../hooks/useSubscriberLists';
import { OnlyFansLists } from '../../../../types/onlyFansTypes';
import { parseOnlyFansListId } from '../../../../utils/common';
import OnlyFansListsMultiSelector from '../../../common/OnlyFansListsMultiSelector';

type Props = {
    excludedLists: { id: number | OnlyFansLists.Type; name: string }[];
    setExcludedLists: (excludedLists: { id: number | OnlyFansLists.Type; name: string }[]) => void;
    theme: Theme;
};

const MessageUsersFormExcludeList = (props: Props) => {
    const { theme, excludedLists, setExcludedLists } = props;

    const { lists } = useSubscriberLists(true);

    return (
        <>
            <Grid container spacing={1} flexGrow={0} alignItems="center" justifyContent="center">
                <Grid item xs={12}>
                    <Grid
                        container
                        spacing={1}
                        flexGrow={0}
                        alignItems="center"
                        justifyContent="center"
                        sx={{ marginBottom: theme.spacing(2) }}
                    >
                        <Grid item xs={12}>
                            <OnlyFansListsMultiSelector
                                targetLists={excludedLists.map(list => {
                                    return {
                                        id: parseOnlyFansListId(list.id) ?? list.id,
                                        name:
                                            lists?.find(
                                                l =>
                                                    parseOnlyFansListId(l.id) ===
                                                    (parseOnlyFansListId(list.id) ?? parseOnlyFansListId(list.id)),
                                            )?.name || 'Unknown',
                                    };
                                })}
                                setTargetLists={targetLists =>
                                    setExcludedLists(
                                        targetLists.map(list => ({
                                            id: parseOnlyFansListId(list.id) ?? list.id,
                                            name: list.name,
                                        })),
                                    )
                                }
                                listItemBackgroundColor={alpha(theme.palette.error.main, 0.3)}
                                showSelectedListsChips={true}
                                sx={{
                                    backgroundColor: alpha(theme.palette.error.main, 0.1),
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Alert severity="info">All the users in the selected lists will NOT receive the message</Alert>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default MessageUsersFormExcludeList;
